import script from "./TarefasCentralDoCoordenador.vue?vue&type=script&setup=true&lang=js"
export * from "./TarefasCentralDoCoordenador.vue?vue&type=script&setup=true&lang=js"

import "./TarefasCentralDoCoordenador.vue?vue&type=style&index=0&id=f2a6aaa6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2a6aaa6"]])

export default __exports__